import { render, staticRenderFns } from "./SaveProfileModal.vue?vue&type=template&id=736663cb&scoped=true"
import script from "./SaveProfileModal.vue?vue&type=script&lang=js"
export * from "./SaveProfileModal.vue?vue&type=script&lang=js"
import style0 from "./SaveProfileModal.vue?vue&type=style&index=0&id=736663cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736663cb",
  null
  
)

export default component.exports